import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=4f729109&scoped=true&"
import script from "./Privileges.vue?vue&type=script&lang=js&"
export * from "./Privileges.vue?vue&type=script&lang=js&"
import style0 from "./Privileges.vue?vue&type=style&index=0&id=4f729109&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f729109",
  null
  
)

export default component.exports